// ============================================================================
// AGENT STATUS
// ============================================================================

export const AGENT_STATUS = ["draft", "released", "deployed", "active", "archived"] as const;
export type AgentStatusType = (typeof AGENT_STATUS)[number];

// ============================================================================
// PUBLICATION STATUS
// ============================================================================

export const PUBLICATION_STATUS = ["not_published", "pending_review", "approved", "rejected", "suspended"] as const;
export type PublicationStatusType = (typeof PUBLICATION_STATUS)[number];

// ============================================================================
// KNOWLEDGE BASE STATUS
// ============================================================================

export const KB_STATUS = ["draft", "released", "archived"] as const;
export type KbStatusType = (typeof KB_STATUS)[number];

// ============================================================================
// AUTHENTICATION
// ============================================================================

export const PERSONAL_INFO_FIELDS = ["dateOfBirth", "yearOfBirth", "lastName", "firstName", "postalCode"] as const;
export type PersonalInfoFieldType = (typeof PERSONAL_INFO_FIELDS)[number];

// ============================================================================
// RETELL CONFIGURATION
// ============================================================================

export const RETELL_AMBIENT_SOUNDS = [
  "coffee-shop",
  "convention-hall",
  "summer-outdoor",
  "mountain-outdoor",
  "static-noise",
  "call-center",
] as const;
export type RetellAmbientSoundType = (typeof RETELL_AMBIENT_SOUNDS)[number];

// ============================================================================
// RETELL VOICE MODELS
// ============================================================================

export const RETELL_VOICE_MODELS = [
  "eleven_turbo_v2",
  "eleven_flash_v2",
  "eleven_turbo_v2_5",
  "eleven_flash_v2_5",
  "eleven_multilingual_v2",
  "sonic-2",
  "sonic-3",
  "sonic-3-latest",
  "sonic-turbo",
  "tts-1",
  "gpt-4o-mini-tts",
  "speech-02-turbo",
] as const;
export type RetellVoiceModelType = (typeof RETELL_VOICE_MODELS)[number];

// ============================================================================
// RETELL DATA STORAGE SETTINGS
// ============================================================================

export const RETELL_DATA_STORAGE_SETTINGS = ["everything", "everything_except_pii", "basic_attributes_only"] as const;
export type RetellDataStorageSettingType = (typeof RETELL_DATA_STORAGE_SETTINGS)[number];

// ============================================================================
// RETELL VOICEMAIL ACTIONS
// ============================================================================

export const RETELL_VOICEMAIL_ACTIONS = ["hangup", "prompt", "static_text", "bridge_transfer"] as const;
export type RetellVoicemailActionType = (typeof RETELL_VOICEMAIL_ACTIONS)[number];

// ============================================================================
// RETELL POST CALL ANALYSIS MODELS
// ============================================================================

export const RETELL_POST_CALL_ANALYSIS_MODELS = [
  "gpt-4.1",
  "gpt-4.1-mini",
  "gpt-4.1-nano",
  "gpt-5",
  "gpt-5.1",
  "gpt-5.2",
  "gpt-5-mini",
  "gpt-5-nano",
  "claude-4.5-sonnet",
  "claude-4.5-haiku",
  "gemini-2.5-flash",
  "gemini-2.5-flash-lite",
  "gemini-3.0-flash",
] as const;
export type RetellPostCallAnalysisModelType = (typeof RETELL_POST_CALL_ANALYSIS_MODELS)[number];

// ============================================================================
// RETELL STT CONFIGURATION
// ============================================================================

export const RETELL_STT_MODES = ["fast", "accurate", "custom"] as const;
export type RetellSttModeType = (typeof RETELL_STT_MODES)[number];

export const RETELL_STT_PROVIDERS = ["azure", "deepgram"] as const;
export type RetellSttProviderType = (typeof RETELL_STT_PROVIDERS)[number];

// ============================================================================
// RETELL VOCABULARY SPECIALIZATION
// ============================================================================

export const RETELL_VOCAB_SPECIALIZATION = ["general", "medical"] as const;
export type RetellVocabSpecializationType = (typeof RETELL_VOCAB_SPECIALIZATION)[number];

// ============================================================================
// RETELL DENOISING MODES
// ============================================================================

export const RETELL_DENOISING_MODES = ["noise-cancellation", "noise-and-background-speech-cancellation"] as const;
export type RetellDenoisingModeType = (typeof RETELL_DENOISING_MODES)[number];

// ============================================================================
// RETELL PII CATEGORIES
// ============================================================================

export const RETELL_PII_CATEGORIES = [
  "person_name",
  "address",
  "email",
  "phone_number",
  "ssn",
  "passport",
  "driver_license",
  "credit_card",
  "bank_account",
  "password",
  "pin",
  "medical_id",
  "date_of_birth",
  "customer_account_number",
] as const;
export type RetellPiiCategoryType = (typeof RETELL_PII_CATEGORIES)[number];

// ============================================================================
// CALL SESSION STATUS
// ============================================================================

export const CALL_SESSION_STATUS = ["pending", "in_progress", "completed", "failed", "cancelled"] as const;
export type CallSessionStatusType = (typeof CALL_SESSION_STATUS)[number];

export const CALL_SESSION_TYPE = ["scheduled", "callback", "retry"] as const;
export type CallSessionTypeType = (typeof CALL_SESSION_TYPE)[number];

// ============================================================================
// TEST CALL STATUS
// ============================================================================

export const TEST_CALL_STATUS = [
  "pending",
  "registered",
  "ongoing",
  "ended",
  "failed",
  "no_answer",
  "disconnected",
  "voicemail",
  "busy",
  "wrong_number",
  "unknown",
] as const;
export type TestCallStatusType = (typeof TEST_CALL_STATUS)[number];

export const TEST_RESULT = ["success", "partial", "failed"] as const;
export type TestResultType = (typeof TEST_RESULT)[number];
